// libraries
import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
// general
import { getSelectedScale } from 'state/devices'
import { useGetScaleReadingLazyQuery } from 'services/devices'

export function useScaleState() {
  const [request, setRequest] = useState({})
  const selectedScaleId = useSelector(state => getSelectedScale(state?.devices))?.id
  const enableScaleIntegration = // this setting is global; not just for IBTs
    useSelector(state => state.settings)?.settings?.purchaseSettings?.scaleView?.enableScaleIntegration
  const [getScaleReading, { data: scaleReading, isFetching }] = useGetScaleReadingLazyQuery()

  const readScaleFn = (cb, scaleIdOverride) => {
    if (isFetching) return
    const newRequest = {
      id: Date.now(),
      callback: cb,
    }
    setRequest(newRequest)
    getScaleReading({ deviceId: scaleIdOverride || selectedScaleId, requestId: newRequest.id })
  }

  useEffect(async () => {
    if (scaleReading && request.callback) {
      request.callback(scaleReading.scaleData)
    }
  }, [scaleReading])

  return {
    isFetchingScaleReading: isFetching,
    showScaleButton: !!(selectedScaleId && enableScaleIntegration),
    readScale: readScaleFn,
  }
}
